// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\Billing\QuickBooks\QuickBooksExportRequest.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { QBExportableDispatchEvent as _QBExportableDispatchEvent, QBExportableDispatchEventData as _QBExportableDispatchEventData, QBExportableDispatchEventOptions as _QBExportableDispatchEventOptions, QBExportablePilotJobOrder as _QBExportablePilotJobOrder, QBExportablePilotJobOrderData as _QBExportablePilotJobOrderData, QBExportablePilotJobOrderOptions as _QBExportablePilotJobOrderOptions, QBGroupedDispatchEventCharges as _QBGroupedDispatchEventCharges, QBGroupedDispatchEventChargesData as _QBGroupedDispatchEventChargesData, QBGroupedDispatchEventChargesOptions as _QBGroupedDispatchEventChargesOptions, QBGroupedPilotJobOrderCharges as _QBGroupedPilotJobOrderCharges, QBGroupedPilotJobOrderChargesData as _QBGroupedPilotJobOrderChargesData, QBGroupedPilotJobOrderChargesOptions as _QBGroupedPilotJobOrderChargesOptions } from 'data/models/QuickBooksExportRequest';
import { QuickBooksJobTracking, QuickBooksJobTrackingData, QuickBooksJobTrackingOptions } from 'data/models/QuickBooksJobTracking';

// QuickBooksExportRequestData is the class that QuickBooksExportRequest serializes to/from
export interface QuickBooksExportRequestData {
	
    GroupedDispatchEventCharges : _QBGroupedDispatchEventChargesData[] | null;
    GroupedPilotJobOrderCharges : _QBGroupedPilotJobOrderChargesData[] | null;
	
    InvoiceDate : /* ISO8601 */ string;
}

// QuickBooksExportRequestOptions is the class which may be passed to the QuickBooksExportRequest constructor to define optional initial data values
export interface QuickBooksExportRequestOptions {
	
    GroupedDispatchEventCharges? : _QBGroupedDispatchEventChargesOptions[] | null;
    GroupedPilotJobOrderCharges? : _QBGroupedPilotJobOrderChargesOptions[] | null;
	
    InvoiceDate? : /* ISO8601 */ string;
}

export class QuickBooksExportRequest {
	
    public GroupedDispatchEventCharges : SDataArray<_QBGroupedDispatchEventCharges>;
    public GroupedPilotJobOrderCharges : SDataArray<_QBGroupedPilotJobOrderCharges>;
	
    public InvoiceDate : DataSignal<TZDate>;

    constructor();
    constructor(data : QuickBooksExportRequestOptions);
    constructor(data: QuickBooksExportRequestOptions | null = null) {
	    
        this.GroupedDispatchEventCharges = SArray<_QBGroupedDispatchEventCharges>([]);
        this.GroupedPilotJobOrderCharges = SArray<_QBGroupedPilotJobOrderCharges>([]);
	    
        this.InvoiceDate = jsonableObservable(S.value<TZDate>(data && data.InvoiceDate !== undefined ? new TZDate(data.InvoiceDate) : new TZDate(0), TZDate.eq));
    }

    static key(obj : QuickBooksExportRequest) {
        return ;
    }
    
    static dataKey(obj : QuickBooksExportRequestOptions) {
        return ;
    }

    static update(obj : QuickBooksExportRequest, data : QuickBooksExportRequestOptions) {
        S.freeze(() => {
	        
	        
            if (data.InvoiceDate !== undefined) obj.InvoiceDate(new TZDate(data.InvoiceDate));
        });
    }
}

// QBGroupedPilotJobOrderChargesData is the class that QBGroupedPilotJobOrderCharges serializes to/from
export interface QBGroupedPilotJobOrderChargesData {
	
    PilotJobOrders : _QBExportablePilotJobOrderData[] | null;
    VesselId : number | null;
	
    QBTracking : QuickBooksJobTrackingData;
}

// QBGroupedPilotJobOrderChargesOptions is the class which may be passed to the QBGroupedPilotJobOrderCharges constructor to define optional initial data values
export interface QBGroupedPilotJobOrderChargesOptions {
	
    PilotJobOrders? : _QBExportablePilotJobOrderOptions[] | null;
    VesselId? : number | null;
	
    QBTracking? : QuickBooksJobTrackingOptions;
}

export class QBGroupedPilotJobOrderCharges {
	
    public PilotJobOrders : SDataArray<_QBExportablePilotJobOrder>;
    public VesselId : DataSignal<number | null>;
	
    public QBTracking : QuickBooksJobTracking;

    constructor();
    constructor(data : QBGroupedPilotJobOrderChargesOptions);
    constructor(data: QBGroupedPilotJobOrderChargesOptions | null = null) {
	    
        this.PilotJobOrders = SArray<_QBExportablePilotJobOrder>([]);
        this.VesselId = jsonableObservable(S.value<number | null>(data && data.VesselId !== undefined ? data.VesselId : null));
	    
        this.QBTracking = data && data.QBTracking !== undefined ? new QuickBooksJobTracking(data.QBTracking) : new QuickBooksJobTracking();
    }

    static key(obj : QBGroupedPilotJobOrderCharges) {
        return ;
    }
    
    static dataKey(obj : QBGroupedPilotJobOrderChargesOptions) {
        return ;
    }

    static update(obj : QBGroupedPilotJobOrderCharges, data : QBGroupedPilotJobOrderChargesOptions) {
        S.freeze(() => {
	        
            if (data.VesselId !== undefined) obj.VesselId(data.VesselId);
	        
            if (data.QBTracking !== undefined) QuickBooksJobTracking.update(obj.QBTracking, data.QBTracking);
        });
    }
}

// QBGroupedDispatchEventChargesData is the class that QBGroupedDispatchEventCharges serializes to/from
export interface QBGroupedDispatchEventChargesData {
	
    DispatchEvents : _QBExportableDispatchEventData[] | null;
	
    QBTracking : QuickBooksJobTrackingData;
}

// QBGroupedDispatchEventChargesOptions is the class which may be passed to the QBGroupedDispatchEventCharges constructor to define optional initial data values
export interface QBGroupedDispatchEventChargesOptions {
	
    DispatchEvents? : _QBExportableDispatchEventOptions[] | null;
	
    QBTracking? : QuickBooksJobTrackingOptions;
}

export class QBGroupedDispatchEventCharges {
	
    public DispatchEvents : SDataArray<_QBExportableDispatchEvent>;
	
    public QBTracking : QuickBooksJobTracking;

    constructor();
    constructor(data : QBGroupedDispatchEventChargesOptions);
    constructor(data: QBGroupedDispatchEventChargesOptions | null = null) {
	    
        this.DispatchEvents = SArray<_QBExportableDispatchEvent>([]);
	    
        this.QBTracking = data && data.QBTracking !== undefined ? new QuickBooksJobTracking(data.QBTracking) : new QuickBooksJobTracking();
    }

    static key(obj : QBGroupedDispatchEventCharges) {
        return ;
    }
    
    static dataKey(obj : QBGroupedDispatchEventChargesOptions) {
        return ;
    }

    static update(obj : QBGroupedDispatchEventCharges, data : QBGroupedDispatchEventChargesOptions) {
        S.freeze(() => {
	        
	        
            if (data.QBTracking !== undefined) QuickBooksJobTracking.update(obj.QBTracking, data.QBTracking);
        });
    }
}

// QBExportablePilotJobOrderData is the class that QBExportablePilotJobOrder serializes to/from
export interface QBExportablePilotJobOrderData {
    Id : number;
	
	
    ApprovalDate : /* ISO8601 */ string;
}

// QBExportablePilotJobOrderOptions is the class which may be passed to the QBExportablePilotJobOrder constructor to define optional initial data values
export interface QBExportablePilotJobOrderOptions {
    Id : number;
	
	
    ApprovalDate? : /* ISO8601 */ string;
}

export class QBExportablePilotJobOrder {
    public Id : DataSignal<number>;
	
	
    public ApprovalDate : DataSignal<TZDate>;

    constructor();
    constructor(data : QBExportablePilotJobOrderOptions);
    constructor(data: QBExportablePilotJobOrderOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
	    
        this.ApprovalDate = jsonableObservable(S.value<TZDate>(data && data.ApprovalDate !== undefined ? new TZDate(data.ApprovalDate) : new TZDate(0), TZDate.eq));
    }

    static key(obj : QBExportablePilotJobOrder) {
        return obj.Id();
    }
    
    static dataKey(obj : QBExportablePilotJobOrderOptions) {
        return obj.Id;
    }

    static update(obj : QBExportablePilotJobOrder, data : QBExportablePilotJobOrderOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
            if (data.ApprovalDate !== undefined) obj.ApprovalDate(new TZDate(data.ApprovalDate));
        });
    }
}

// QBExportableDispatchEventData is the class that QBExportableDispatchEvent serializes to/from
export interface QBExportableDispatchEventData {
    Id : number;
	
	
    ApprovalDate : /* ISO8601 */ string;
}

// QBExportableDispatchEventOptions is the class which may be passed to the QBExportableDispatchEvent constructor to define optional initial data values
export interface QBExportableDispatchEventOptions {
    Id : number;
	
	
    ApprovalDate? : /* ISO8601 */ string;
}

export class QBExportableDispatchEvent {
    public Id : DataSignal<number>;
	
	
    public ApprovalDate : DataSignal<TZDate>;

    constructor();
    constructor(data : QBExportableDispatchEventOptions);
    constructor(data: QBExportableDispatchEventOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
	    
        this.ApprovalDate = jsonableObservable(S.value<TZDate>(data && data.ApprovalDate !== undefined ? new TZDate(data.ApprovalDate) : new TZDate(0), TZDate.eq));
    }

    static key(obj : QBExportableDispatchEvent) {
        return obj.Id();
    }
    
    static dataKey(obj : QBExportableDispatchEventOptions) {
        return obj.Id;
    }

    static update(obj : QBExportableDispatchEvent, data : QBExportableDispatchEventOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
            if (data.ApprovalDate !== undefined) obj.ApprovalDate(new TZDate(data.ApprovalDate));
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/QuickBooksExportRequest.ts